// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".news .filter-row .filter-label[data-v-4f08b362],.news .news-list .news-list-inner-wrapper .news-list-box-text-block .news-desc[data-v-4f08b362],.news .news-list .news-list-inner-wrapper .news-list-box-text-block span[data-v-4f08b362],.news .news-list .show-more span[data-v-4f08b362]{will-change:transform}.news .news-list .news-list-inner-wrapper .news-list-box-text-block span[data-v-4f08b362]{display:inline-block}", ""]);
// Exports
module.exports = exports;
